import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllCretater, resetInitialState, subscribeToTeacher, unsubscribetoTeacher, updateCreatorSubscription } from '../../actions/subscribers';
import { fetchAllCretaterforHomePage } from '../../actions/landingPageActions';
import { Alert, Spinner } from 'react-bootstrap';
import { CreatorCard } from './CreatorCard';
import './AllCreators.css';
import { fetchUserDataRequest } from '../../actions/dashboardActions';
import SEO from '../common/SEO';

export const AllCreators = ({ limit = null }) => {
  const dispatch = useDispatch();

  // Redux selectors
  const isAuthenticated = localStorage.getItem('userId') ? true : false;
  const allCreterwithSubStatus = useSelector(state => state.subcriptiondata.allCreterwithSubStatus);
  const isallCreterwithSubStatusloading = useSelector(state => state.subcriptiondata.isallCreterwithSubStatusloading);
  const allCreterDataforhomepage = useSelector(state => state.landingpagedata.allCreterDataforhomepage);
  const loadingforhome = useSelector(state => state.landingpagedata.loadingforhome);
  const subcribeFail = useSelector(state => state.subcriptiondata.subcribeFail);
  const unsubcribeFail = useSelector(state => state.subcriptiondata.unsubcribeFail);
  const studentProfileData = useSelector(state => state.dashboard.userData);

  // State
  const [loading, setLoading] = useState({});

  // Determine which data to use based on authentication status
  const creators = isAuthenticated ? allCreterwithSubStatus : allCreterDataforhomepage;
  const sortedCreators = creators?.sort((a, b) => (b.subscribers?.length || 0) - (a.subscribers?.length || 0));

  const displayedCreators = limit ? sortedCreators?.slice(0, limit) : creators;
  const isLoading = isAuthenticated ? isallCreterwithSubStatusloading : loadingforhome;
  const userRole = localStorage.getItem('userRole');
  const [showError, setShowError] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isAuthenticated && !allCreterwithSubStatus.length) {
      dispatch(fetchAllCretater());
    } else if (!isAuthenticated && !allCreterDataforhomepage.length) {
      dispatch(fetchAllCretaterforHomePage());
    }

  }, [isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated && studentProfileData.length === 0) {
      dispatch(fetchUserDataRequest())
    }

  }, [])

  useEffect(() => {
    if (subcribeFail || unsubcribeFail) {
      // Show error message immediately
      setError(subcribeFail ? 'Subscription failed. Please try again.' : 'Unsubscription failed. Please try again.');
      setShowError(true);

      // Set timeout to hide error and refetch after 3 seconds
      const timer = setTimeout(() => {
        setShowError(false);
        dispatch(resetInitialState())
        dispatch(fetchAllCretater());
      }, 3000);

      // Clean up the timer if component unmounts
      return () => clearTimeout(timer);
    }
  }, [subcribeFail, unsubcribeFail]);

  useEffect(() => {
    setLoading({});
  }, [allCreterwithSubStatus]);

  const handleSubscribe = (id) => {
    if (userRole === 'creator') {
      alert('Creators cannot subscribe & unsubscribe to other creators');
      return;
    }
    // setLoading(prev => ({ ...prev, [id]: true }));
    dispatch(subscribeToTeacher(id));
    const isSubscribed = true
    dispatch(updateCreatorSubscription(id, studentProfileData._id, isSubscribed))
  };

  const handleUnsubscribe = (id) => {
    // setLoading(prev => ({ ...prev, [id]: true }));
    dispatch(unsubscribetoTeacher(id));
    const isSubscribed = false
    dispatch(updateCreatorSubscription(id, studentProfileData._id, isSubscribed))
  };

  if (isLoading) {
    return (
      <div className="all-creators-container">
        <div className="section-header">
          <h2>Top Creators</h2>
          <p>Subscribe to your favorite educators and access their content</p>
        </div>
        <div className="d-flex justify-content-center align-items-center" style={{ height: '30vh', color: '#0096c7' }}>
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      </div>
    );
  }

  if (!displayedCreators || displayedCreators.length === 0) {
    return (
      <div className="all-creators-container">
        <div className="section-header">
          <h2>Top Creators</h2>
          <p>Subscribe to your favorite educators and access their content</p>
        </div>
        <div className="no-creators-message">
          <p>No creators found</p>
        </div>
      </div>
    );
  }

  // Generate SEO data
  const seoTitle = "All Educators - My Exam World";
  const seoDescription = "Discover top educators and creators on My Exam World. Subscribe to access exclusive content, test series, and learning materials from expert teachers.";
  const seoKeywords = "educators, teachers, online learning, subscribe to teachers, exam preparation, test series, online education, top educators";
  const seoUrl = "/allcreators";

  return (
    <div className="all-creators-container">
      {!limit &&
        <SEO
          title={seoTitle}
          description={seoDescription}
          keywords={seoKeywords}
          url={seoUrl}
        />}
      <div className="section-header">
        <h2>Top Creators</h2>
        <p>Subscribe to your favorite educators and access their content</p>
      </div>
      {showError && error && (
        <Alert variant="danger" onClose={() => setShowError(false)} dismissible>
          {error}
        </Alert>
      )}

      <div className="creators-grid">
        {displayedCreators?.map((creator) => (
          <CreatorCard
            key={creator._id}
            creator={{
              ...creator,
              subscribers: creator.subscribers || []
            }}
            isAuthenticated={isAuthenticated}
            onSubscribe={handleSubscribe}
            onUnsubscribe={handleUnsubscribe}
            loading={loading}
          />
        ))}
      </div>
    </div>
  );
};